import { IState } from 'shared/store';
import { selectAdfoxOfferResponseData } from 'shared/store/adfoxParams/selectors/selectAdfoxOfferResponseData';

export function selectAdfoxParams(state: IState) {
  return selectAdfoxOfferResponseData(state)?.params;
}
